export default __webpack_public_path__ + "static/media/csvError.08025d6d.svg";